__turbopack_context__.v({
  "betaEyebrow": "pricing-module__QqTp4a__betaEyebrow",
  "betaProgram": "pricing-module__QqTp4a__betaProgram",
  "billing": "pricing-module__QqTp4a__billing",
  "card": "pricing-module__QqTp4a__card",
  "cardHeading": "pricing-module__QqTp4a__cardHeading",
  "controls": "pricing-module__QqTp4a__controls",
  "cta": "pricing-module__QqTp4a__cta",
  "description": "pricing-module__QqTp4a__description",
  "grid": "pricing-module__QqTp4a__grid",
  "help": "pricing-module__QqTp4a__help",
  "helpSection": "pricing-module__QqTp4a__helpSection",
  "hero": "pricing-module__QqTp4a__hero",
  "iceSurface": "pricing-module__QqTp4a__iceSurface",
  "inheritance": "pricing-module__QqTp4a__inheritance",
  "intro": "pricing-module__QqTp4a__intro",
  "limitsNote": "pricing-module__QqTp4a__limitsNote",
  "plans": "pricing-module__QqTp4a__plans",
  "price": "pricing-module__QqTp4a__price",
  "switch": "pricing-module__QqTp4a__switch",
  "tableSection": "pricing-module__QqTp4a__tableSection",
  "trial": "pricing-module__QqTp4a__trial",
});
